import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import './TeacherOversight.css';

const TeacherOversight = () => {
  const [term, setTerm] = useState('');
  const [session, setSession] = useState('');
  const [classGrade, setClassGrade] = useState('');
  const [teacherData, setTeacherData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const db = getDatabase();
    const dataRef = ref(db, 'teachers');

    const unsubscribe = onValue(dataRef, (snapshot) => {
      let data = [];
      if (snapshot.exists()) {
        data = Object.values(snapshot.val());

        // Apply filters
        if (term) data = data.filter(item => item.term === term);
        if (session) data = data.filter(item => item.session === session);
        if (classGrade) data = data.filter(item => item.class === classGrade);
      }

      setTeacherData(data);
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup listener
  }, [term, session, classGrade]);

  const handleDownloadExcel = () => {
    alert("Excel download coming soon!");
  };

  const handleDownloadPDF = () => {
    alert("PDF download coming soon!");
  };

  return (
    <div className="teacher-oversight">
      <h2>Teacher Oversight</h2>

      <div className="report-filters">
        <label>Term:</label>
        <select value={term} onChange={(e) => setTerm(e.target.value)}>
          <option value="">Select Term</option>
          <option value="First">First Term</option>
          <option value="Second">Second Term</option>
          <option value="Third">Third Term</option>
        </select>

        <label>Session:</label>
        <input
          type="text"
          placeholder="e.g. 2024/2025"
          value={session}
          onChange={(e) => setSession(e.target.value)}
        />

        <label>Class/Grade:</label>
        <input
          type="text"
          placeholder="e.g. Primary 5"
          value={classGrade}
          onChange={(e) => setClassGrade(e.target.value)}
        />
      </div>

      {loading && <p>Loading data...</p>}

      {teacherData.length > 0 && (
        <div className="report-preview">
          <h3>Teacher Data</h3>
          <table>
            <thead>
              <tr>
                {Object.keys(teacherData[0]).map((key) => (
                  <th key={key}>{key.toUpperCase()}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {teacherData.map((item, index) => (
                <tr key={index}>
                  {Object.values(item).map((val, idx) => (
                    <td key={idx}>{val}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          <div className="report-actions">
            <button onClick={handleDownloadPDF}>Download PDF</button>
            <button onClick={handleDownloadExcel}>Download Excel</button>
          </div>
        </div>
      )}

      {!loading && teacherData.length === 0 && <p>No data found for the selected filters.</p>}
    </div>
  );
};

export default TeacherOversight;
